import React from 'react';
import { motion } from 'framer-motion';
import { ChefHatIcon } from 'lucide-react';
interface Recipe {
  titulo: string;
  imagen: string;
}
const RECETAS: Recipe[] = [{
  titulo: 'Granola Casera',
  imagen: 'https://cdn.magicpatterns.com/uploads/6fEvpFzgxwUKq4pyTMLqba/Granola_Casera.png'
}, {
  titulo: 'Peras al Malbec',
  imagen: 'https://cdn.magicpatterns.com/uploads/5VwBxLSJBEZinaPLKiW6t3/Peras_al_Malbec_(Version_Air_Fryer).png'
}, {
  titulo: 'Pan de Queso',
  imagen: 'https://cdn.magicpatterns.com/uploads/n13o3XcFQwSYfm4Frcf4g3/Pan_de_Queso.png'
}, {
  titulo: 'Manzanas Asadas de la Abuela',
  imagen: 'https://cdn.magicpatterns.com/uploads/gMrHXHSksRrKGHoGq7Geon/Manzanas_Asadas_De_la_Abuela.png'
}, {
  titulo: 'Brownie Húmedo de 15 Minutos',
  imagen: 'https://cdn.magicpatterns.com/uploads/4TAdEdm7i5oyrtNYBPdiYw/Brownie_Humedo_de_15_Minutos.png'
}, {
  titulo: 'Banana Asada con Dulce de Leche',
  imagen: 'https://cdn.magicpatterns.com/uploads/iofgwwPxh8dMdgMR6wCKs3/Banana_Asada_con_Dulce_de_Leche.png'
}, {
  titulo: 'Rolls de Manzana y Hojaldre',
  imagen: 'https://cdn.magicpatterns.com/uploads/cJuPkFXJKUYSsRmwJ2M3KW/Rolls_de_Manzana_y_Hojaldre.png'
}, {
  titulo: 'Bastoncitos de Muzzarella',
  imagen: 'https://cdn.magicpatterns.com/uploads/151hqY86b5ZHTYHHkXTjUX/Bastoncitos_de_Muzzarella_(Muzzarellita.png'
}, {
  titulo: 'Canastitas de Verduras',
  imagen: 'https://cdn.magicpatterns.com/uploads/jaGta4isrxB1XYpDRg1nU2/canastitas_de_verduras.png'
}, {
  titulo: 'Pizza Casera',
  imagen: 'https://cdn.magicpatterns.com/uploads/twDBhXtVfFsZQpPiBo6hn2/pizza_2.png'
}, {
  titulo: 'Bife de Chorizo Jugoso',
  imagen: 'https://cdn.magicpatterns.com/uploads/u5HkQFo3ySf9vbEYPjYeMk/carne.png'
}, {
  titulo: 'Tostado de Carne y Queso',
  imagen: 'https://cdn.magicpatterns.com/uploads/4p2ZB12dkTfSuDFkt6FNRj/tostada.png'
}, {
  titulo: 'Asado al Aire',
  imagen: 'https://cdn.magicpatterns.com/uploads/oSJBgmPkwnm6L9GidRyWcJ/asado.png'
}, {
  titulo: 'Provoleta Fundida',
  imagen: 'https://cdn.magicpatterns.com/uploads/hiDGtijVrTvmYpBoZaYjtb/provoleta.png'
}, {
  titulo: 'Tarta de Verduras',
  imagen: 'https://cdn.magicpatterns.com/uploads/3bbTc21DSFwsCXxmzXPrjf/tarta.png'
}, {
  titulo: 'Empanadas Doradas',
  imagen: 'https://cdn.magicpatterns.com/uploads/3gTT2Ez7sp425PZAgYr1zH/empanadas.png'
}];
export function RecipeGallerySection() {
  return <section className="w-full bg-amber-50 py-10 sm:py-16" data-id="element-173" data-mp="101qf2ow1g0oc">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-174" data-mp="150a4x0dr5wlz">
        <div className="mx-auto max-w-4xl text-center" data-id="element-175" data-mp="14yqlx20pp7gi">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-yellow-400 px-3 py-1 text-xs font-black uppercase text-neutral-900" data-id="element-176" data-mp="191vm2xxbkx1z">
            <ChefHatIcon className="h-3.5 w-3.5" data-id="element-177" data-mp="2gh9sjip5nn9o" /> Resultados que vas a lograr
          </span>
          <h2 className="mt-4 text-2xl font-black leading-tight text-neutral-950 sm:text-3xl lg:text-4xl" data-id="element-178" data-mp="2kez6sz6d5e4i">
            APRENDERÁS A PREPARAR ESTOS PLATOS EN TU AIRFRYER SIN SER UN EXPERTO Y SIN EXPERIENCIA EN LA COCINA.
          </h2>
          <p className="mt-4 text-lg font-medium text-neutral-700 sm:text-xl" data-id="element-179" data-mp="vbmu5y5k1k">
            Basta de deliverys caros, comé rico, rápido y casero.
          </p>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-3 sm:grid-cols-3 sm:gap-5 lg:grid-cols-4" data-id="element-180" data-mp="3r5bw1o6pxeum">
          {RECETAS.map((receta, index) => <motion.figure key={receta.titulo} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.35,
          delay: Math.min(index * 0.035, 0.28)
        }} className="overflow-hidden rounded-2xl bg-neutral-950 shadow-md" data-id="element-181" data-mp="3h8qnwtzejnmk" data-mpi={index}>
              <img src={receta.imagen} alt={receta.titulo} className="aspect-[4/5] w-full object-cover" data-id="element-182" data-mp="16h7dp6bw3m2f" />
              <figcaption className="min-h-12 px-3 py-2.5 text-center text-xs font-black leading-tight text-white sm:text-sm" data-id="element-183" data-mp="372z1fbbmtb3">
                {receta.titulo}
              </figcaption>
            </motion.figure>)}
        </div>

        <p className="mx-auto mt-7 max-w-2xl text-center text-sm font-semibold leading-relaxed text-neutral-600" data-id="element-184" data-mp="3v9u3k39u9100">
          Y esto es apenas una muestra: dentro del MegaPack tenés 250 recetas explicadas paso a paso, con ingredientes que conseguís en cualquier súper argentino.
        </p>
      </div>
    </section>;
}